import { atom } from 'jotai'

export const authAtom = atom<
  null | { id: number; name: string; role: number } | undefined
>(undefined)
